import { ENGLISH, GERMAN, SWEDISH, FINNISH } from 'constants/locale';

export const getLanguageCodeByCountryCode = (
  countryCode: string | undefined,
): string | undefined => {
  let lang;
  switch (countryCode) {
    case 'FI':
      lang = FINNISH;
      break;
    case 'SE':
      lang = SWEDISH;
      break;
    case 'DE':
      lang = GERMAN;
      break;
    default:
      lang = ENGLISH;
      break;
  }
  return lang;
};
